export enum TransactionTabName {
  Account = 'account',
  Ads = 'ads',
  PaidAds = 'paid-ads',
}

export enum OperationDirection {
  Income = 'income',
  Expense = 'expense',
}

export interface OperationAd {
  id: string;
  legacyResourceId: number;
  title: string;
  price?: number;
  image?: string;
  path: string;
}

export interface Operation {
  id: string;
  serviceId: string;
  operationNumber: string;
  serviceName: string;
  amount: number;
  formattedAmount: string;
  paymentMethod?: string;
  paymentMethodLabel?: string;
  date: string;
  direction: OperationDirection;
  isIncome: boolean;
  isRefund: boolean;
  isPaidAds: boolean;
  ad?: OperationAd;
  refund?: RefundDetails;
  invoiceId?: string;
  invoiceUrl?: string;
}

export interface RefundDetails {
  paidServiceName: string;
  paidPaymentMethodLabel?: string;
  adNumber?: string;
  rrn?: string;
}
